module.exports = __webpack_public_path__ + "static/media/pulverizador.22f6e3fd.svg";